var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',_vm._b({attrs:{"false-value":false,"true-value":true,"input-value":_vm.input,"persistent-hint":""},on:{"change":_vm.changeState}},'v-switch',_vm.commonProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }